var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1>Профиль</h1><router-view></router-view>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/profile/template.jade
 ** module id = 116
 ** module chunks = 0
 **/